import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getProductListDataViewProperty } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductListPageContext } from "@insite/content-library/Pages/ProductListPage";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import themeColors, { themeFontSizes, themeFontWeights, themeIndentSizes } from "@MasterBluePrint/Styles/variables";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";


interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: ApplicationState) => {
    const pagination = getProductListDataViewProperty(state, "pagination");
    const correctedQuery = getProductListDataViewProperty(state, "correctedQuery");
    const { productFilters } = state.pages.productList;
    return {
        totalItemCount: pagination?.totalItemCount,
        query: correctedQuery || productFilters.query,
        pageSize: pagination?.pageSize,
    };
};

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

export interface ProductListProductCountStyles {
    wrapper?: InjectableCss;
    countText?: TypographyPresentationProps;
    itemsText?: TypographyPresentationProps;
    queryText?: TypographyPresentationProps;
}

export const productCountStyles: ProductListProductCountStyles = {
    wrapper: {
        css: css`
            margin-top: .625rem;
            color: ${themeColors.colorCharcoalGrey};
            font-size: ${themeFontSizes.size14};
            letter-spacing: 0;
            font-style: italic;
            font-weight: 500;
        `,
    },
    countText: {
        css: css`
            white-space: nowrap;
        `,
    },
    queryText: {
        css: css`
            white-space: nowrap;
            font-weight: bold;
        `,
    },
};

const styles = productCountStyles;

const ProductListProductCount: FC<Props> = ({ totalItemCount, query, pageSize }) => {
    if (!totalItemCount) {
        return null;
    } 

    if (!pageSize) {
        return null;
    }

    const itemsText = (totalItemCount !== 1 ? " Results" : " Result");
    const pageSizeNew = (totalItemCount < pageSize ? totalItemCount : pageSize ); 

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.itemsText}>Showing </Typography>
            <Typography {...styles.countText} data-test-selector="productListCountText">
                {pageSizeNew}
            </Typography>
            <Typography {...styles.itemsText}> of </Typography>
            <Typography {...styles.countText} data-test-selector="productListCountText">
                {totalItemCount}
            </Typography>
            <Typography {...styles.itemsText}>{translate(itemsText)}</Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(ProductListProductCount),
    definition: {
        group: "Product List",
        displayName: "Product List Count",
        allowedContexts: [ProductListPageContext],
    },
};

export default widgetModule;
